import { joi } from '../joi.js'

const {
    string: stringSchema,
    array: arraySchema,
    number: numberSchema,
} = joi.types()
const string = stringSchema.empty([null, ''])
const number = numberSchema.empty([null, ''])
const requiredArray = arraySchema.$.min(1)

const offerSchema = joi
    .object()
    .unknown(true)
    .keys({
        industry: string.label('業界').required(),
        qualification: string.label('募集職種').required(),
        employmentType: string.label('雇用形態').required(),
        workShift: string.label('勤務形態').required(),
        workingHours: requiredArray
            .rule({
                message: '{{#label}}を入力してください',
            })
            .items(
                joi.object({
                    from: string.required().label('開始時刻'),
                    to: string.required().label('終了時刻'),
                    rest: number.required().label('休憩時間'),
                })
            )
            .label('勤務時間')
            .custom((value, helpers) => {
                // 配列の中のオブジェクトで1つでも未入力やエラーがあれば親にまとめる
                const hasError = value.some((item) => !item.from || !item.to || !item.rest)
                if (hasError) {
                    return helpers.error('any.invalid') // 親のエラーとして出す
                }
                return value
            }, 'workingHours custom validation')
            .messages({
                'any.invalid': '{{#label}}の内容に不備があります',
            }),
        incomeDisplayClass: string.label('給与').required(),
        hourlyIncomeMin: number
            .label('時給')
            .when('incomeDisplayClass', { is: '時給', then: joi.required() }),
        daylyIncomeMin: number
            .label('日給')
            .when('incomeDisplayClass', { is: '日給', then: joi.required() }),
        monthlyIncomeMin: number
            .label('月給')
            .when('incomeDisplayClass', { is: '月給', then: joi.required() }),
        annualIncomeMin: number
            .label('年収')
            .when('incomeDisplayClass', { is: '年収', then: joi.required() }),
    })

const pageSchema = joi
    .object()
    .unknown(true)
    .keys({
        shortCaComment: string.label('ひとこと').required(),
        tags: requiredArray
            .rule({
                message: '{{#label}}を選択してください',
            })
            .label('おすすめポイント'),
        offer: offerSchema.empty(null),
    })

export const editFormSchema = joi
    .object()
    .unknown(true)
    .keys({
        facilities: arraySchema,
        pages: arraySchema.items(pageSchema),
    })
